const initialValue = {
  vendorinvoicesOptions: [],
  selectedInvoices: [],
}

export default initialValue
